import React, { useEffect, useState } from 'react'
import AIResponseLoadingGIF from '../../assets/loaders/adnoc-loading.gif';
import { Box, Typography } from '@mui/material';

const PROGRESS_TEXTS = ['Analyzing your input...', 'Generating response...']

export default function AIRepsonseLoadingProgress({ textColor }: {textColor?: string}) {
    const [progressText, setProgressText] = useState(PROGRESS_TEXTS[0])
    useEffect(() => {
        const interval = setInterval(() => {
            setProgressText(PROGRESS_TEXTS[1]);
        }, 1500);

        return () => {
            clearInterval(interval);
        }
    }, [])
    return (
        <Box sx={{
            width: '100%',
            display: 'grid',
            placeContent: 'center',
            justifyItems: 'center'
        }}>
            <img
                src={AIResponseLoadingGIF}
                alt='.'
                style={{
                    width: '4vw',
                    aspectRatio: 1 / 1
                }}></img>
            <Typography variant='body1' color={textColor}>
                {progressText}
            </Typography>
        </Box>
    )
}
